export default {
  "de-DE": {
    "text001": "Startseite",
    "text002": "Über diese Website",
    "text003": "Ergebnisse",
    "text004": "Wähle nach Spieltitel",
    "text005": "Wähle einen zufälligen Helden",
    "text006": "Heldenliste",
    "text007": "Informationen zum Event",
    "text008": "Sprachauswahl",
    "text009": "Fire Emblem Heroes Offizielle Website",
    "text010": "Auf dem offiziellen Twitter-Account findest du die neuesten Informationen zu Fire Emblem Heroes."
  },
  "en-GB": {
    "text001": "Home page",
    "text002": "About this site",
    "text003": "Results",
    "text004": "Choose by Game Title",
    "text005": "Choose a Random Hero",
    "text006": "Battle Ballot",
    "text007": "Event Details",
    "text008": "Language selection",
    "text009": "Fire Emblem Heroes Official Site",
    "text010": "You can find out the latest information on Fire Emblem Heroes on the official Twitter account."
  },
  "es-ES": {
    "text001": "Inicio",
    "text002": "Acerca de este sitio",
    "text003": "Resultados",
    "text004": "Elegir por juego",
    "text005": "Elegir un héroe al azar",
    "text006": "Registro",
    "text007": "Detalles de la campaña",
    "text008": "Idioma",
    "text009": "Sitio oficial de Fire Emblem Heroes",
    "text010": "Puedes leer las últimas novedades de Fire Emblem Heroes en la cuenta oficial de Twitter."
  },
  "fr-FR": {
    "text001": "Page d'accueil",
    "text002": "À propos de ce site",
    "text003": "Résultats",
    "text004": "Choisir un jeu",
    "text005": "Héros au hasard",
    "text006": "Historique",
    "text007": "À propos de l'événement",
    "text008": "Sélection de la langue",
    "text009": "Site officiel de Fire Emblem Heroes",
    "text010": "Découvrez les dernières informations de Fire Emblem Heroes sur le compte Twitter officiel."
  },
  "it-IT": {
    "text001": "Pagina principale",
    "text002": "Informazioni su questo sito",
    "text003": "Risultati",
    "text004": "Scegli per titolo",
    "text005": "Scegli un eroe casuale",
    "text006": "Lista scelte",
    "text007": "Dettagli sull'evento",
    "text008": "Lingua",
    "text009": "Sito ufficiale di Fire Emblem Heroes",
    "text010": "Tutte le informazioni più recenti su Fire Emblem Heroes si trovano sull'account Twitter ufficiale."
  },
  "ja-JP": {
    "text001": "トップページ",
    "text002": "英雄総選挙とは",
    "text003": "結果発表",
    "text004": "タイトルを選んで投票",
    "text005": "ランダム投票",
    "text006": "マイページ",
    "text007": "英雄総選挙の詳細",
    "text008": "言語切替",
    "text009": "ファイアーエムブレム ヒーローズ公式サイト",
    "text010": "公式アカウントで最新情報を手に入れよう"
  },
  "zh-TW": {
    "text001": "首頁",
    "text002": "英雄總選舉是什麼？",
    "text003": "公布結果",
    "text004": "選擇遊戲名稱進行投票",
    "text005": "隨機投票",
    "text006": "My Page",
    "text007": "英雄總選舉之詳情",
    "text008": "切換語言",
    "text009": "Fire Emblem Heroes 官方網站",
    "text010": "前往官方帳號獲取最新的情報！"
  },
  "en-US": {
    "text001": "Home Page",
    "text002": "About This Site",
    "text003": "Results",
    "text004": "Choose by Game Title",
    "text005": "Choose a Random Hero",
    "text006": "Battle Ballot",
    "text007": "Event Details",
    "text008": "Language selection",
    "text009": "Fire Emblem Heroes Official Site",
    "text010": "You can find out the latest information on Fire Emblem Heroes on the official Twitter account."
  },
  "es-MX": {
    "text001": "Inicio",
    "text002": "Acerca de este sitio",
    "text003": "Resultados",
    "text004": "Elegir por juego",
    "text005": "Elegir un héroe al azar",
    "text006": "Boleta",
    "text007": "Detalles del evento",
    "text008": "Idioma",
    "text009": "Sitio oficial de Fire Emblem Heroes",
    "text010": "Puedes leer las últimas novedades de Fire Emblem Heroes en la cuenta oficial de Twitter de Nintendo."
  },
  "fr-CA": {
    "text001": "Page d'accueil",
    "text002": "À propos de ce site",
    "text003": "Résultats",
    "text004": "Choisir un jeu",
    "text005": "Héros au hasard",
    "text006": "Historique",
    "text007": "À propos de l'événement",
    "text008": "Sélection de la langue",
    "text009": "Site officiel de Fire Emblem Heroes",
    "text010": "Découvrez les dernières informations concernant Fire Emblem Heroes sur le compte Twitter officiel."
  },
  "pt-BR": {
    "text001": "Página inicial",
    "text002": "Sobre esta página",
    "text003": "Resultados",
    "text004": "Escolher por título de jogo",
    "text005": "Escolher um herói aleatório",
    "text006": "Cédula",
    "text007": "Detalhes do evento",
    "text008": "Selecionar idioma",
    "text009": "Página oficial de Fire Emblem Heroes",
    "text010": "Você pode conferir as informações mais recentes sobre Fire Emblem Heroes na conta oficial da Nintendo no Twitter."
  }
}